import apiFetch from '../apiFetch'

export default function (token, data, fleetId) {
  return apiFetch({ endPoint: `UnattendedProcess/SetOperateDataFinancingFleet/${fleetId}`, method: 'POST', body: data, token: token })
}
